import React from 'react';
import { IconBaseProps, IconType } from 'react-icons';

const renderIcon = (icon: IconType, props: IconBaseProps = {}) => {
  // Cast the icon as any to avoid TypeScript errors
  return React.createElement(icon as any, props);
};

export default renderIcon;
